export const formatUploadLink = (link: string): string => {
  return `https:${link}`;
};

export const defaultSettingsObject = {
  auth_content_type: 'string',
  auth_header: 'Authorization',
  auth_param: 'access_token',
  token_type: 'Bearer',
  use_pkce: false
};

export const MappingFieldsList = [
  'map_email',
  'map_id',
  'map_firstname',
  'map_lastname',
  'map_nickname',
  'map_birthday',
  'map_attributes',
  'map_partner_data'
];

export const ExcludedValidationFieldsList = [...MappingFieldsList, 'scope'];
